import { instanceConexao } from "services/axiosServices";
import { AxiosRequestConfig } from "axios";
import { useQuery } from "@tanstack/react-query";

/**
 * Função para buscar as imobiliárias dentro do conexão.
 *
 * @param {string} authToken - Token de autenticação do usuário.
 * @returns {UseQueryResult<any, unknown>} - Resultado da query.
 *
 * A resposta é um array de objetos com as propriedades:
 * - id: Identificador da imobiliária.
 * - nome: Nome da imobiliária.
 */
export function fetchImobiliariasListar({
  enabled,
  authToken,
}: {
  enabled?: boolean;
  authToken: string;
}): any {
  const fetch = async (): Promise<any> => {
    const url = "api/imobiliarias/ListarPorFiltro";
    const config: AxiosRequestConfig = {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    };
    const response = await instanceConexao.post(url, {}, config);
    return response?.data?.data?.data;
  };

  const query = useQuery({
    queryFn: async () => fetch(),
    queryKey: ["fetch-imobiliarias-listar"],
    enabled: enabled ?? false,
    refetchOnWindowFocus: false,
  });

  return query;
}

/**
 * Função para listar as imobiliárias através de uma requisição POST.
 *
 * @param {string} authToken - Token de autenticação do usuário.
 * @returns {Promise<any>} - Retorna a resposta da API contendo os dados das imobiliárias.
 *
 * A resposta contém os dados das imobiliárias disponíveis, como identificador e nome.
 */
export const postImobiliariasListar = async (
  authToken: string
): Promise<any> => {
  const url = "api/imobiliarias/ListarPorFiltro";
  const config: AxiosRequestConfig = {
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
  };
  const response = await instanceConexao.post(url, {}, config);
  return response?.data?.data;
};
